import { type Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { COUNTRY_NAME_MAPPINGS } from '@/constants/locale';
import { useRules } from '@/hooks/use-rules';
import { useConfigStore } from '@/store/use-config-store';
import { FormText } from './form-text';

interface FormPhoneInputProps {
  control: Control<any>;
}

export const FormPhoneInput: React.FC<FormPhoneInputProps> = (props) => {
  const { control } = props;
  const { t, i18n } = useTranslation();
  const areaCodeList = useConfigStore((state) => state.areaCodeList);
  const rules = useRules();

  const options = areaCodeList.map((item) => ({
    value: item.prefix,
    label: `${COUNTRY_NAME_MAPPINGS[i18n.language]?.[item.code]} (${item.prefix})`,
  }));

  return (
    <div className="flex gap-4">
      <Controller
        name="areaCode"
        control={control}
        render={({ field }) => (
          <FormControl sx={{ width: 158 }}>
            <InputLabel id="region-select-label">{t('region')}</InputLabel>
            <Select
              {...field}
              size="small"
              labelId="region-select-label"
              id="region-select"
              label={t('region')}
              renderValue={(value) => value}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                PaperProps: {
                  style: { maxHeight: 300 },
                },
              }}
            >
              {options.map((o) => (
                <MenuItem key={o.value} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />

      <FormText
        number
        name="phone"
        label={t('phone_number')}
        control={control}
        rules={rules.phone}
        slotProps={{
          inputLabel: {
            className: 'first-letter:capitalize',
          },
        }}
      />
    </div>
  );
};
